<script setup>
import { DatePickerGridHead } from 'reka-ui';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
});
</script>

<template>
    <DatePickerGridHead v-bind="props">
        <slot />
    </DatePickerGridHead>
</template>
